module.exports = __webpack_public_path__ + "img/step-two-icon.582edec9.jpg";